var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayTwoIsometric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.16 391.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#999;}.cls-3{fill:#e3e3e5;}.cls-4{fill:#2b2b2b;}.cls-5{fill:#1e1e1e;}.cls-6{fill:#7f7f7f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.39,231.13C517.13,228.78,318.89,22.68,311,14.35c-8.55-8.95-19.88-4.84-20.09-4.76.1,0,.66-.27-9.53,2.65-10.79,3.08-14.29-.8-14.29-.8s-4-5.24-17.63-1.29C233.58,14.73,7.86,72.09,7.86,72.09S.77,73.91.69,81.17,0,125.93,0,125.93,195.25,377.31,202.91,387.27c6.27,8.2,22,2.49,22,2.49s284.08-103,290.7-105.41c5.81-2.49,5.39-7.66,5.39-7.66l.13-37.91S521.36,233.24,519.39,231.13ZM420.5,172.26l-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35L313.93,59.24a12.75,12.75,0,0,1,11.54,3.2L422.34,165C425,167.78,424.16,171.06,420.5,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M481.84,185.58C480,183.62,314.76,11.86,308.13,4.93,301-2.53,291.57.89,291.4,1c.08,0,.55-.23-7.94,2.2-9,2.58-11.92-.66-11.92-.66s-3.29-4.36-14.69-1.07C243.66,5.24,55.56,53,55.56,53s-5.91,1.52-6,7.57S49,97.91,49,97.91s162.71,209.48,169.1,217.78c5.22,6.83,18.35,2.08,18.35,2.08S473.2,232,478.71,229.92c4.84-2.07,4.5-6.38,4.5-6.38l.1-31.59S483.48,187.34,481.84,185.58ZM420.5,172.26l-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35L313.93,59.24a12.75,12.75,0,0,1,11.54,3.2L422.34,165C425,167.78,424.16,171.06,420.5,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M479.22,182.73S314.76,11.75,308.13,4.81c-7.11-7.46-16.56-4-16.73-4,.08,0,.55-.22-7.94,2.21-9,2.57-11.92-.66-11.92-.66S268.25-2,256.85,1.31C243.66,5.12,55.56,52.93,55.56,52.93s-8.71,3-3.6,9.42L100.56,126S208.07,261.24,216.11,271.29s23.12,3.88,23.12,3.88,227.06-77.39,237.78-81S479.22,182.73,479.22,182.73ZM420.5,172.26l-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35L313.93,59.24a12.75,12.75,0,0,1,11.54,3.2L422.34,165C425,167.78,424.16,171.06,420.5,172.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "240.92 281.15 240.92 308.67 473.74 224.48 473.74 201.17 240.92 281.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "473.74 201.17 457.39 206.84 473.74 224.48 473.74 201.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.26,128.13l-7.76,1.57c17.27,21.72,105.36,132.53,112.61,141.59A15.61,15.61,0,0,0,227.86,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M479.22,182.73S408.69,109.41,358.15,56.84l-4.08,1.74L481.48,191.4C484.51,187.57,479.22,182.73,479.22,182.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.8,58.53c-8.47,2.19-26.71,8.67-16.64,21.56s24.94,13.26,42.42,8.43,132.73-36.46,143.9-39.6,25.7-9.77,12.89-21.8S268,18.41,253.61,22.2,124.28,56.33,115.8,58.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.21,13.22l-2-2-25.08,6.74a31.13,31.13,0,0,1,3.67,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.59,70.72,63.9,78.07l1.92,2.51,25.8-6.91A9.15,9.15,0,0,1,91.59,70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M320.42,17.6l-1.95-2-22.27,6a29,29,0,0,1,2.45,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M67.41,82.62l1.93,2.5,24.23-6.47A17.48,17.48,0,0,1,92.28,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M302.75,27.77l21.75-5.92-1.94-2L301,25.69c.32.33.64.67.94,1S302.48,27.42,302.75,27.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.39,81.29,71.33,87.8l1.94,2.49L97.4,83.7c-.47-.53-1-1.08-1.42-1.65C95.77,81.79,95.59,81.54,95.39,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75,92.56,77,95.05l25.17-6.89c-.88-.69-1.74-1.44-2.59-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M328.59,26.1l-1.93-2-22.24,6.05a16.87,16.87,0,0,1,1.17,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.24,96.8l2,2.48,27.69-7.54a30.71,30.71,0,0,1-3.51-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M306.39,37.37l26.16-7.16-1.93-2-24.31,6.61A8.81,8.81,0,0,1,306.39,37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M428.45,165.28,328.84,59.9A16.44,16.44,0,0,0,314,55.79l-183.54,51.5c-4.77,1.34-6.13,5.59-3,9.44l94.33,117.15a14,14,0,0,0,14.18,4.17l190.15-63.39C430.79,173.1,431.85,168.87,428.45,165.28Zm-7.95,7-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35L313.93,59.24a12.75,12.75,0,0,1,11.54,3.2L422.34,165C425,167.78,424.16,171.06,420.5,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329.27,217.59c-3.12-1.08-3.11-2.79,0-3.82l22.32-7.3c3.13-1,5.27.8,4.74,4.06l-1.55,9.58a4.9,4.9,0,0,1-6.63,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayTwoIsometric);
export default __webpack_public_path__ + "static/media/gray-two-isometric.c7615773e1668056d89648a3a5d62183.svg";
export { ForwardRef as ReactComponent };